import React from "react";
import { useTranslation } from "react-i18next";


const Loading = () => {
    const { t } = useTranslation();
    return (
      <div className="my-5  d-flex flex-row justify-content-center align-items-center loading">
        <span className="z-1 center spinner">
          <div className="spinner-in position-absolute z-2 dark-mode"></div>
        </span>
        <span className="px-2">{t("Loading")}</span>
      </div>
    );
  
};

export default Loading;